var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnElectronic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q3hdj9ea5a",
    d: "M0 0.009L14.979 0.009 14.979 10.903 0 10.903z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -415) translate(126 415) translate(0 .088)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "17xwl69a3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q3hdj9ea5a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M7.504.644c-.428 0-.856-.005-1.283.004-.083.002-.18.039-.243.09-.107.087-.105.216-.06.334.048.128.16.18.295.181.438.002.876.001 1.314.001h1.252c.163 0 .275-.074.314-.197.072-.234-.062-.411-.317-.413-.424-.002-.848 0-1.272 0zm4.202 2.863h2.048V2.456h-2.048v1.051zm-10.492 0h2.054V2.46H1.214v1.048zm2.429 2.66c0 2.048 1.717 3.713 3.836 3.719 2.119.006 3.842-1.657 3.85-3.715.009-2.044-1.732-3.727-3.846-3.72-2.124.008-3.84 1.668-3.84 3.716zM1.617 1.432V.776h1.651v.65c.036.002.065.006.094.006.347 0 .693-.002 1.04.002.069 0 .1-.02.121-.083.072-.223.15-.444.225-.665.149-.442.467-.674.946-.675 1.205-.003 2.41-.003 3.616 0 .463.001.79.236.94.662.08.227.158.455.237.683.015.043.027.078.093.078.45-.004.902-.002 1.353-.003.013 0 .026-.002.046-.005v-.65H13.6v.656h.435c.475.006.828.284.925.733.015.072.016.148.016.223 0 2.519-.002 5.038.003 7.557.001.51-.325.844-.69.926-.088.02-.18.03-.27.03-4.353.002-8.706.002-13.06.001-.492 0-.837-.263-.944-.718C0 10.127 0 10.067 0 10.009L0 2.345c0-.525.385-.905.93-.912.226-.004.45 0 .687 0z",
    mask: "url(#17xwl69a3b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M4.278 6.234c-.029 1.74 1.452 3.182 3.308 3.12 1.735-.058 3.116-1.42 3.107-3.074-.01-1.867-1.532-3.166-3.272-3.132-1.881.038-3.177 1.54-3.143 3.086",
    transform: "translate(-126 -415) translate(126 415)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnElectronic);
export default __webpack_public_path__ + "static/media/icn_electronic.22b99ccfc062d5e7e83d4640955e594f.svg";
export { ForwardRef as ReactComponent };